import * as React from "preact";
import { render } from "preact";

import App from "./App";

function init() {
  const el = document.getElementById("device-detect-and-redirect-app");
  if (el) {
    const { iphoneUrl, androidUrl, defaultUrl } = el.dataset;
    const data = { iphoneUrl, androidUrl, defaultUrl };

    render(<App redirectUrls={data} />, el);
  }
}

export default { init };
